import { useContext } from 'react';
import styled from 'styled-components';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { linkToUsersAndTeamSettings } from '../../urls/linkToUsersAndTeamSettings';
import { TrackUsageContext } from '../../usage-tracking/contexts/TrackUsageContext';
import { useUnassignedSeatsBanner } from '../hooks/useUnassignedSeatsBanner';
import { trackClickManagePaidUsers } from '../utils/event-handlers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AlertWrapper = styled(UIAlert).withConfig({
  displayName: "UnassignedSeatsBanner__AlertWrapper",
  componentId: "sc-1aax2jx-0"
})(["margin:-16px -20px;&&&{padding-left:12px;padding-right:12px;border:none;}"]);
const Wrapper = styled.div.withConfig({
  displayName: "UnassignedSeatsBanner__Wrapper",
  componentId: "sc-1aax2jx-1"
})(["display:flex;align-items:center;"]);
const UnassignedSeatsBanner = ({
  onClose
}) => {
  const trackUsage = useContext(TrackUsageContext);
  const {
    isFetching,
    unassignedSeatCount
  } = useUnassignedSeatsBanner(onClose);
  return /*#__PURE__*/_jsx(AlertWrapper, {
    closeable: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Wrapper, {
      children: [isFetching && /*#__PURE__*/_jsx(UILoadingSpinner, {}), /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.routingRules.unassignedSeats_jsx",
        elements: {
          UILink
        },
        options: {
          unassignedCount: unassignedSeatCount,
          linkProps: {
            external: true,
            use: 'on-bright',
            onClick: () => trackUsage(trackClickManagePaidUsers('banner')),
            href: linkToUsersAndTeamSettings(true)
          }
        }
      })]
    })
  });
};
UnassignedSeatsBanner.displayName = 'UnassignedSeatsBanner';
export default UnassignedSeatsBanner;